/**
 * static/js/utils/dialog-close.js
 *
 * Sitewide safety net for the `.close-modal` convention. Native <dialog>s across
 * the site use a `.close-modal` element (a Cancel button or an "x") to dismiss
 * themselves, but there is no shared handler: each page re-wires it ad hoc and a
 * page that forgets leaves its modal with no way to close (e.g. the Add Payment
 * Method dialog). This delegated listener closes the nearest enclosing <dialog>
 * for any `.close-modal` click, regardless of per-page wiring.
 *
 * Additive and idempotent: closing an already-closed <dialog> is a no-op, so it
 * coexists with the existing per-page `$('.close-modal').on('click', ...)`
 * handlers without double-close side effects. It does not preventDefault, so it
 * never interferes with a `.close-modal` that is also a link or submit control.
 *
 * Loaded on every page via the common bundle (entries/common.js).
 */
(function (window, document) {
  'use strict';

  if (window.__jn_dialog_close_wired) return;
  window.__jn_dialog_close_wired = true;

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.close-modal');
    if (!trigger) return;
    var dialog = trigger.closest('dialog');
    if (dialog && typeof dialog.close === 'function') dialog.close();
  });
})(window, document);
